<div class="landing-container">
  <!-- Regular Landing Content (always shown) -->
  <div class="content-wrapper">
    <div class="logo-section">
      <div class="logo-container">
        <div class="logos-wrapper">
          <img src="assets/ypen.png" alt="ΥΠΕΝ Λογότυπο" class="logo-image">
          <img src="assets/deddie-logo.svg" alt="ΔΕΔΗΕ Λογότυπο" class="logo-image">
        </div>
        <!-- <h2 class="logo-title centered-title">{{ 'SYSTEM_TITLE' | translate }}</h2> -->
      </div>
    </div>
    
    <div class="info-box">
      <p class="info-text" style="text-align: justify;">
        {{ 'LANDING_1' | translate }}
      </p>
      <p class="info-text" style="text-align: justify;">
        {{ 'LANDING_2' | translate }}
      </p>
      
      <p class="info-text" style="text-align: justify;">
        {{ 'LANDING_3' | translate }}
      </p>
      <div class="info-groups">
        <div class="group-item" style="text-align: justify;">
          <span class="group-number">α.</span> {{ 'LANDING_4' | translate }}
        </div>
        <div class="group-item" style="text-align: justify;">
          <span class="group-number">β.</span> {{ 'LANDING_5' | translate }}
        </div>
        <div class="group-item" style="text-align: justify;">
          <span class="group-number">γ.</span> {{ 'LANDING_6' | translate }}
        </div>
        <div class="group-item" style="text-align: justify;">
          <span class="group-number">δ.</span> {{ 'LANDING_7' | translate }}
        </div>
      </div>
    </div>
    
    <div class="bottom-section">
      <button (click)="login()" class="login-button">
        {{ 'LOGIN_TAXIS' | translate }}
      </button>
    </div>
  </div>
</div>